import { Avatar } from '../../Atomics/Avatar';
import Box from '../../Atomics/Box';
import { Button } from '../../Atomics/Button';
import { Heading } from '../../Atomics/Heading';
import { Paragraph } from '../../Atomics/Paragraph';
import CustomIcon from '../../Icons/CustomIcon';

type TProps = {
    title: string;
    description: string;
    ctaText?: string;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

const ErrorFeedback = ({ title, description, ctaText, onClick }: TProps) => {
    return (
        <Box display="flex" flexDirection="column" alignItems="center">
            <Box mb="md">
                <Avatar border="none" position="relative" bg="error-4" size={96}>
                    <CustomIcon icon="ErrorIcon" customColor="white" width={48} height={48} />
                </Avatar>
            </Box>

            <Heading level={2} mt="lg" mb="sm" textAlign="center">{title}</Heading>
            <Paragraph typography="text-s-medium" textAlign="center" mb="lg">{description}</Paragraph>

            {ctaText && <Button size="s" variant='primary-black' onClick={onClick}>{ctaText}</Button>}
        </Box>
    );
};

export default ErrorFeedback;
